module.exports = __webpack_public_path__ + "images/standard-default.c78f502df46d8cf19cc32230cb4c1167.png";